import React from 'react'
import {Icon} from '@chakra-ui/react'

const HotIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <path
                d="M12.946 7.00024C10.7229 9.11752 7.61048 14.7813 12.946 20.4979C18.2816 26.2146 15.1692 31.349 12.946 33.2016"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M20.321 7.00024C18.0979 9.11752 14.9855 14.7813 20.321 20.4979C25.6565 26.2146 22.5442 31.349 20.321 33.2016"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M27.6941 7.00024C25.4709 9.11752 22.3585 14.7813 27.6941 20.4979C33.0296 26.2146 29.9172 31.349 27.6941 33.2016"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </Icon>
    )
}

export default HotIcon
